export default "__VITE_ASSET__BjgCvb3w__"